import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_49: DocMigration = {
  maxSchemaVersion: "0.0.49",
  description: "Flatten tables",
  apply(json: any) {
    const { tables } = json;

    json.settings = tables.settings;
    json.palettes = tables.palettes;
    delete json.tables;

    return json;
  },
};

export default migration_0_0_49;
